import { RequestConfig } from 'common/types/api'

export const GROWTH_REQUEST_CONFIG: RequestConfig = {
  getGrowthLineChart: { method: 'GET', url: '/shrimp-growth/line-chart' },
  getGrowthToday: {method: 'GET', url: '/shrimp-growth/today'},
  getGrowths: { method: 'GET', url: '/shrimp-growth' },
  createGrowth: { method: 'POST', url: '/shrimp-growth' },
  editGrowth: { method: 'PATCH', url: '/shrimp-growth' },
  deleteGrowth: { method: 'DELETE', url: '/shrimp-growth' },
}
